import React from "react";
import { Section, Eyebrow } from "../components/ui-shared";

const Wrapper = ({ eyebrow, title, children }) => (
  <Section className="min-h-[60vh]">
    <div className="max-w-3xl">
      <Eyebrow>{eyebrow}</Eyebrow>
      <h1 className="mt-3 font-display text-3xl sm:text-4xl font-bold tracking-tight text-white">{title}</h1>
      <div className="mt-6 space-y-4 text-sm sm:text-base text-slate-400 leading-relaxed">{children}</div>
    </div>
  </Section>
);

export const Privacy = () => (
  <Wrapper eyebrow="Legal" title="Privacy Policy">
    <p>Neo Orbit collects the information you submit through our Private Beta application forms — such as your name, contact details and campaign or creator information — solely to evaluate and manage Private Beta onboarding.</p>
    <p>We do not sell your data. Information is stored securely and used only to operate and improve Orbit during the beta.</p>
    <p>You may request access to or deletion of your submitted application information by contacting us.</p>
  </Wrapper>
);

export const Terms = () => (
  <Wrapper eyebrow="Legal" title="Terms of Use">
    <p>Orbit is currently in Private Beta. Access is offered to a limited group of businesses and creators and may change as the product evolves.</p>
    <p>Submitting an application does not guarantee Private Beta access, campaign opportunities or any specific outcome.</p>
    <p>During the Private Beta, businesses are not charged a platform fee. Access requirements, if any, are separate from platform fees.</p>
  </Wrapper>
);

export const Contact = () => (
  <Wrapper eyebrow="Get in touch" title="Contact">
    <p>For questions about the Neo Orbit Private Beta, please submit an application and our team will reach out regarding onboarding.</p>
    <p>Businesses and creators can apply through the respective Private Beta application forms on this site.</p>
    <div className="pt-2">
      <p className="eyebrow">Contact</p>
      <a
        href="mailto:founder@neoorbit.co"
        data-testid="contact-email-link"
        className="mt-2 inline-block font-display text-xl sm:text-2xl font-semibold text-white hover:text-sky-300 transition-colors"
      >
        founder@neoorbit.co
      </a>
    </div>
  </Wrapper>
);
